// Proprietà e costanti di configurazione per la tabella macchine

export const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num, isNumber: true },
  // { name: 'id', title: 'ID', getCellValue: row => row.id, isNumber: true },
  { name: 'actions', title: 'Actions', getCellValue: row => row },
  { name: 'created_at', title: 'Created At', getCellValue: row => row.created_at },
  { name: 'updated_at', title: 'Updated At', getCellValue: row => row.updated_at },
  { name: 'name', title: 'Description', getCellValue: row => row.name },
  //{ name: 'description', title: 'Description', getCellValue: row => row.description },
  { name: 'com_brand', title: 'Com Brand', getCellValue: row => row.com_brand },
  { name: 'ecu_type', title: 'ECU Type', getCellValue: row => row.ecu_type },
  { name: 'kit_code', title: 'Kit Code', getCellValue: row => row.kit_code },
  { name: 'rail_code', title: 'Rail Code', getCellValue: row => row.rail_code },
  { name: 'rail2_code', title: 'Rail2 Code', getCellValue: row => row.rail2_code },
  { name: 'other_accessories', title: 'Other Accessories', getCellValue: row => row.other_accessories },
  { name: 'status', title: 'Status', getCellValue: row => row.status },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'id', width: 80 },
  { columnName: 'actions', width: 120 },
  { columnName: 'created_at', width: 120 },
  { columnName: 'updated_at', width: 120 },
  { columnName: 'name', width: 510 },
  { columnName: 'com_brand', width: 80 },
  // { columnName: 'description', width: 500 },
  { columnName: 'ecu_type', width: 120 },
  { columnName: 'kit_code', width: 140 },
  { columnName: 'rail_code', width: 140 },
  { columnName: 'rail2_code', width: 140 },
  { columnName: 'other_accessories', width: 140 },
  { columnName: 'status', width: 120 },
];

/**
 * @type {import('@devexpress/dx-react-grid-material-ui').ColumnExtension[]}
 */
export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'id', align: 'right' },  
  { columnName: 'created_at', align: 'right' },
  { columnName: 'updated_at', align: 'right' },  
];

export const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },
  { columnName: 'created_at', filteringEnabled: false },
  { columnName: 'updated_at', filteringEnabled: false },
];
